/**
 * @generated SignedSource<<2fd99303951e5cde14659f7acd4cf128>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerPostMagazineQuery$data = {
  readonly postMagSection: {
    readonly subSections: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"entityOnelineMenuQueueItemsEdge">;
        }>;
      } | null | undefined;
    } | null | undefined;
  };
  readonly " $fragmentType": "headerPostMagazineQuery";
};
export type headerPostMagazineQuery$key = {
  readonly " $data"?: headerPostMagazineQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerPostMagazineQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerPostMagazineQuery",
  "selections": [
    {
      "alias": "postMagSection",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "71"
          }
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Queue",
          "kind": "LinkedField",
          "name": "subSections",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemConnection",
              "kind": "LinkedField",
              "name": "items",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "QueueItemsEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "entityOnelineMenuQueueItemsEdge"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "section(filter:{\"entityId\":\"71\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "58ea792b9bafbe11e7c99f1d40b0786e";

export default node;
